<ul class="table-body-wrapper" [ngClass]="tableBodyClass" [class.table-fixed]="simplified">
  @for (row of tableRows | paginate: { id: paginationId, itemsPerPage: itemsPerPage, currentPage: page, totalItems: totalCount }; track $index; let rowIndex = $index) {
    @if (loading) {
      <span class="list-row gap-column-xs loading">
        @for (cell of row?.cells; let cellIndex = $index; track cellIndex) {
          <div class="am-flex gap-xxs b-none-i m0 p0"
              [class.am-flex-center]="cell.xs_icons"
              [ngClass]="cell.class">
            @if (cell.xs_label)                 { <span class="xs-label mt-xs mb-xs loading-animate"></span> }
            @if (cell.value || cell.valueClass) { <span class="width-full height-l  loading-animate"></span> }
            @for (child of cell.children; let childIndex = $index; track childIndex) { <entries-nested-child [ngClass]="child.class" [child]="child" [indexes]="[rowIndex, cellIndex, childIndex]"></entries-nested-child> }
            @for (child of cell.xs_icons; let childIndex = $index; track childIndex) { <div class="am-flex-center"><span class="width-xl height-xl loading-animate"></span></div> }
            @if (cell.buttons) { <div class="buttons-group"> @for (button of cell.buttons; track $index) { <button [ngClass]="button.class" class="loading-animate font-l">{{ button.label }}</button> } </div> }
          </div>
        }
      </span>
    } @else if (row) {
      <li class="list-row"
         [class.bold]="     row?.bold"
         [class.read-only]="row?.read_only"
         [class.deleted]="  row?.deleted"
         [ngClass]="        row?.extra_styles"
         (click)="callbackHandler($event, rowIndex)">
        @for (cell of row?.cells; track cell; let cellIndex = $index) {
          <div [ngClass]="cell?.class" (click)="callbackHandler($event, rowIndex, cellIndex)">
            @if (cell?.input) {
              <input [ngClass]="cell?.input.class" type="checkbox" [id]="cell?.input.id" [checked]="cell?.input.active">
              <label [for]="cell?.input.id"></label>
            }
            @if (cell?.xs_label) { <div class="xs-label">{{ cell?.xs_label }}</div> }
            @if (cell.xs_icons)  {
              <div class="xs-label-icons am-flex-align gap-s">
                @for (icon of cell.xs_icons; track icon) {
                  <span [ngClass]="icon.class" [style.opacity]="icon.show" [class.events-none]="!icon.show">{{ icon.value }}</span>
                }
              </div>
            }
            @if (cell.toggler) {
              <toggler [currentValue]="cell.toggler.init"
                       [leftValue]="cell.toggler.left"
                       [rightValue]="cell.toggler.right"
                       (togglerCallback)="cell.toggler.click($event)">
              </toggler>
            }
            @if (cell.editableInput) {
              <editable-input [index]="        cell.editableInput.index"
                              [editBox]="      cell.editableInput.editBox"
                              [type]="         cell.editableInput.type"
                              [value]="        cell.editableInput.value"
                              [maxValue]="     cell.editableInput.maxValue"
                              [valueType]="    cell.editableInput.valueType"
                              [postValue]="    cell.editableInput.postValue"
                              [showEdit]="     cell.editableInput.showEdit"
                              (toggleEditBox)="cell.editableInput.toggleEditBox($event)"
                              (onValueChange)="cell.editableInput.onValueChange($event)">
              </editable-input>
            }
            @if (cell.value || cell.valueClass) { <span [ngClass]="cell.valueClass">{{ cell.value }}</span> }
            @for (child of cell.children; track child; let childIndex = $index) {
              <entries-nested-child [ngClass]="child.class"
                                    [child]="child"
                                    [indexes]="[rowIndex, cellIndex, childIndex]"
                                    [routerLink]="child.routerLink"
                                    [state]="     child.routerLinkState"
                                    (click)="   callbackHandler($event, rowIndex, cellIndex, childIndex)"
                                    (callback)="callbackHandler($event)">
              </entries-nested-child>
            }
            @if (cell.buttons) {
              <div class="buttons-group">
                @for (button of cell.buttons; track button; let childIndex = $index) {
                  <button [ngClass]="button.class"
                          [routerLink]="button.routerLink"
                          [state]="button.routerLinkState"
                          [ngStyle]="button.tooltip ? {'opacity': '1'} : ''"
                          (click)="buttonCallbackHandler($event, rowIndex, cellIndex, childIndex)">
                    @if (button.icon   ) { <span [ngClass]="button.icon" [class.hover-active]="button.tooltip"></span> }
                    @if (button.label  ) { <span [ngClass]="button.labelClass">{{ button.label }}</span> }
                    @if (button.tooltip) {
                      <span class="web-tooltip bottom short white">
                        <span class="tooltip-title">{{ button.tooltip }}</span>
                      </span>
                    }
                  </button>
                }
              </div>
            }
          </div>
        }
      </li>
    }
  }
</ul>
